import Member from 'iam/models/Member'
import OpportunitiesSearchViewModel from 'opportunities/OpportunitiesSearchViewModel'
import { Observable } from 'rxjs'
import { filter, map, skip, tap } from 'rxjs/operators'

/**
 * Syncs the workspace filter of the Job Searcher when the current member changes.
 *
 * @param searcher
 * @param currentMember$
 */
export function SyncWorkspaceFilter(
  // TODO: I don't like this but the Jobs/Ops split was important to get done.
  //  Need to make this nicer.
  searcher: OpportunitiesSearchViewModel,
  currentMember$: Observable<Member>,
) {
  return currentMember$.pipe(
    // Skip the first time we get a value here because we want to show "All Jobs/Opportunities" first
    skip(1),
    // Only switch if we were already filtering by a Workspace.
    filter(() => searcher.workspaceFilter.type === 'SpecificWorkspace'),
    map((x) => x.workspace),
    tap(searcher.selectWorkspaceForFiltering),
  )
}
